// extracted by mini-css-extract-plugin
export default {"buttonClass":"style-module--buttonClass--lQXEG","h48":"style-module--h48--eWgGB","buttonWhenInputFocus":"style-module--buttonWhenInputFocus--Fzl-i"};